import styled from 'styled-components'
import { media } from '../../../../layouts/utils'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'

export const Wrapper = styled.div`
  ${media.phone`
    height: content-fit;
    min-height: 500px;
    padding-left: 10px;
    padding-right: 10px;
  `}
  ${media.smallPhone`
    height: content-fit;
    min-height: 450px;
    padding-left: 10px;
    padding-right: 10px;
`}
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 450px;
  padding-top: 40px;
  background: transparent linear-gradient(0deg, #000000 0%, #000000 69%, #000000 100%) 0% 0% no-repeat padding-box;

`

export const Container = styled.div`
  max-width: 500px;
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
  top:100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${media.phone`
    top: 14rem;
  `}
  ${media.smallPhone`
    top: 12rem;
  `}
`

export const Background = styled.img`
  position: absolute;
  z-index: 0;
  top: -200px;
  bottom: 0;
  left: 0;
  width: 100%;
  ${media.phone`
    width: 200%;
    height: 100%;
    left: -70%;
    top: 0;
  `}
  opacity: 0.65;
`

export const TextIntro = styled(Descricao)`
  color: ${props => props.cor};
  text-transform: uppercase;
  padding: 0;
  ${media.phone`
    margin-top: 15px;
    font-size: 12px;
    line-height: 14px;
  `}
`

export const TitleContainer = styled.div`
  ${media.phone`
    width: 100%;
    max-width: 410px;
  `}
  display: inline-block;
  padding-bottom: 20px;
`

export const Title = styled(TituloPrincipal)`
  color: ${props => props.cor};
  line-height: 50px;
  ${media.desktop`
    padding-top: 0;
  `}
  ${media.phone`
    line-height: 38px;
  `}
`

export const ContainerCTA = styled.div`
  ${media.desktop`
    display: block;
    button {
      width: 100%;
    }
  `}
  display: inline;
  ${media.phone`
   margin-bottom: 20px;
  `}
  button {
    width: 180px;
  }
`